import React from 'react';
import styles from './KPICards.module.css';

const getIconAndColor = (label, delta) => {
    let percentageColor = "#000000";
    let percentage = "";

    if (delta < 0) {
        percentage = `▼ ${Math.abs(delta)}%`;
        percentageColor = "#FF544F";
    } else if (delta > 0) {
        percentage = `▲ ${delta}%`;
        percentageColor = "#00A86B";
    } else {
        percentage = `▲ 0%`;
        percentageColor = "#00A86B";
    }

    return { percentageColor, percentage };
};

const KpiCard = ({ count, text, delta, img, isMultipleWeek, type }) => {
    const { percentageColor, percentage } = getIconAndColor(text, delta);

    return (
        <div className={styles.kpiCard}
            style={{
                minWidth: 'auto',
                backgroundImage: `url(${img})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                boxShadow: '0px 8px 10px 0px #959DA533',
                borderRadius: '5px'
            }}
        >
            <span className={styles.kpiText}>{text}</span>
            <span className={styles.count}>{count}</span>
            {
                (text !== 'Contract coverage Wk1 (P1)' && text !== 'MAI details' && text !== 'CBU Coverage %' && text !== 'OR%' && text !== 'Production Plan' && text !== 'OR Loss') &&
                <div className={styles.percentage}>
                    <span style={{ color: percentageColor }} className={styles.percent}>
                        {percentage}
                    </span>
                    <span className={styles.percentText}>vs yesterday</span>
                </div>
            }
            {
                (text === 'OR%' || text === 'Production Plan' || text === 'OR Loss') && !isMultipleWeek && type !== 'Or Loss Tree' &&
                <div className={styles.percentage}>
                    <span style={{ color: percentageColor }} className={styles.percent}>
                        {percentage}
                    </span>
                    <span className={styles.percentText}>vs Last Week</span>
                </div>
            }
        </div>
    );
};

// Main AlertRmpmKpi Component
const AlertRmpmKpi = ({ KPIObj, isMultipleWeek, type }) => {
    return (
        <div className={styles.cardContainer} style={{ width: '100%' }}>
            {KPIObj?.map((kpi) => {
                if (typeof kpi !== "object" || !kpi.label) return null;
                else {
                    return (
                        <KpiCard
                            key={kpi.label}
                            count={kpi.value || 0}
                            text={kpi.label}
                            delta={kpi.delta}
                            img={kpi.img}
                            isMultipleWeek={isMultipleWeek}
                            type={type}
                        />
                    );
                }
            })}
        </div>
    );
};

export default AlertRmpmKpi;